module.exports = __webpack_public_path__ + "59135d3fed26306834c73c60bf41487a.jpg";